import {
  getStoredDeliveryAttempts,
  clearDeliveryAttempts,
  saveDeliveryAttempt,
} from '../utils/indexedDB';
import { verifyOtp } from './api';

export const syncOfflineDeliveries = async () => {
  const deliveryAttempts = await getStoredDeliveryAttempts();

  if (!deliveryAttempts.length) {
    return { successCount: 0, failCount: 0, total: 0, remaining: 0 };
  }

  let successCount = 0;
  let failCount = 0;
  const remaining = [];

  for (const attempt of deliveryAttempts) {
    try {
      const receiverName = attempt.receiverName || 'Offline Delivery';
      await verifyOtp(attempt.orderId, attempt.otp, receiverName);
      successCount += 1;
    } catch (error) {
      failCount += 1;
      // Keep for retry only if it looks like a network failure
      if (!error.response) {
        remaining.push(attempt);
      }
    }
  }

  await clearDeliveryAttempts();
  for (const attempt of remaining) {
    await saveDeliveryAttempt(attempt);
  }

  return {
    successCount,
    failCount,
    total: deliveryAttempts.length,
    remaining: remaining.length,
  };
};

// Backwards-compatible alias
export const syncOfflineData = syncOfflineDeliveries;
